import { usePostHog } from '@posthog/react';
import React, { useEffect } from 'react';

export const PostHogClickTracker: React.FC = () => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    const handler = (e: MouseEvent) => {
      const el = (e.target as Element).closest('[data-track]');
      if (el) {
        posthog.capture('button_clicked', {
          element: el.getAttribute('data-track'),
          label: el.getAttribute('data-track-label') || undefined,
          page: window.location.pathname,
        });
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, [posthog]);

  return null;
};
